<template>
  <div class>
    <v-toolbar dark :color="this.$gf.headerColor()">
      <v-toolbar-title>
        <v-icon class="icon">fa-plus</v-icon>Add Course
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab small @click="closePanel" :color="this.$gf.headerColor()">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-row>
        <v-col md="12">
          <v-form>
            <v-text-field
              :error-messages="messages.name"
              v-model="course.name"
              label="Course Name"
              type="text"
              filled
            ></v-text-field>
            <v-layout>
              <v-flex xs6>
                <v-text-field
                  :error-messages="messages.hours"
                  v-model="course.hours"
                  label="Hours"
                  type="number"
                  class="pr-2"
                  filled
                  :min="0"
                  @keypress="NumbersOnly"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  :error-messages="messages.minutes"
                  v-model="course.minutes"
                  label="Minutes"
                  type="number"
                  class="pl-2"
                  filled
                  :min="0"
                  @keypress="NumbersOnly"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-textarea
              v-model="course.description"
              label="Description"
              hint="Enter a description for this course"
              filled
            ></v-textarea>
            <v-combobox
              v-model="course.topics"
              :search-input.sync="search"
              multiple
              label="Tags"
              append-icon
              chips
              deletable-chips
              class="tag-input"
              filled
            ></v-combobox>
            <drop-zone
              :type="type"
              :accepted="accepted"
              class="mt-5"
              text="Click here to upload Course Image"
            ></drop-zone>
            <label
              v-if="messages.s3_url"
              :error-messages="messages.s3_url"
              class="v-messages theme--light error--text"
              >{{ messages.s3_url[0] }}</label
            >
            <p class="block text-left mt-4 caption">
              Max upload filesize: 10MB <br />
              Accepted file formats: png, jpg
            </p>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
    <v-footer height="68">
      <v-flex px-4 py-4 text-right>
        <v-btn v-if="!s3Uploading" color="primary" @click="closePanel"
          >Cancel</v-btn
        >
        <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn v-else color="primary" class="ml-2" @click="addCourse"
          >Create Course</v-btn
        >
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import courseAPI from '@/api/course.js';
import channelAPI from '@/api/channel.js';
import DropZone from '@/components/global/Dropzone';
export default {
  name: 'CreateCourse',
  components: {
    DropZone,
  },
  props: ['params'],
  data() {
    return {
      type: 'company-logo',
      accepted: 'image/jpg,image/jpeg,image/png',
      course: {},
      channels: [],
      messages: {},
      topics: [],
      search: '',
      imageChanged: false,
      loading: false,
      successMessage: 'Course Successfully Added.',
      errorMessage:
        'Oops, something went wrong! Please check information is correct.',
      waitMessage: 'Please wait, we are uploading your image.',
    };
  },
  computed: {
    s3Uploading() {
      return this.$store.getters.s3Uploading;
    },
  },
  mounted() {
    this.$store.dispatch('setS3Uploading', false);
    this.getChannels();
    this.setEventBus();
  },
  methods: {
    closePanel() {
      this.$emit('closePanel');
    },
    addCourse() {
      this.loading = true;
      courseAPI
        .createCourse(
          this.course,
          this.$store.getters.s3Url,
          this.$store.getters.fileDetails
        )
        .then(() => {
          this.closePanel();
          EventBus.$emit('COURSES_UPDATED', this.params);
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch((err) => {
          this.valid = false;
          this.$snotify.error(this.errorMessage);
          this.messages = this.$gf.errorResponse(err);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    getChannels() {
      channelAPI.getChannels('').then((response) => {
        this.channels = response.data.data;
      });
    },
    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) || charCode == 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    setEventBus() {
      EventBus.$on("FILE_UPLOADED",() => {
        this.$delete(this.messages, "s3_url");
      })
    },
  },
};
</script>
